import { render } from "./SystemAdmin5.vue?vue&type=template&id=66907686"
import script from "./SystemAdmin5.vue?vue&type=script&lang=js"
export * from "./SystemAdmin5.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__